module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9wbmc7YmFzZTY0LGlWQk9SdzBLR2dvQUFBQU5TVWhFVWdBQUFBc0FBQUFIQ0FZQUFBRGVicmRkQUFBQUFYTlNSMElBcnM0YzZRQUFBRlZKUkVGVUdCbGpZQ0FPTU1PVXpRVXkvZ054TUV3QWpRNkJ5cytIaVhkQ0JjeGdBbERhQWlyZWdTYk9zQVFxb1FXVjBJYnlGMEQ1R05SZXFBSU5LTDBkUXdXU0FCTlVFY2dQWDRDWUVVa09KOU1VbXd3QUJCMFJ2YU4zelRrQUFBQUFTVVZPUks1Q1lJST0i"


//////////////////
// WEBPACK FOOTER
// ./wwwroot/images/shared/dropdown-arrow.png
// module id = 483
// module chunks = 6